export const transactionConstants = {
  GETALL_REQUEST: 'TRANSACTIONS_GETALL_REQUEST',
  GETALL_SUCCESS: 'TRANSACTIONS_GETALL_SUCCESS',
  GETALL_FAILURE: 'TRANSACTIONS_GETALL_FAILURE',
}